import { FC } from 'react';
import { Text, CustomChangeEvent } from '@frontend/design-system';
import { errorMessageStyle, fieldLabelTextStyle } from './checklist-field.styles';
import { DropdownChecklistField } from './dropdown-checklist-field';
import { InlineChecklistField } from './inline-checklist-field';

const FIELD_OPTIONS_THRESHOLD = 5;

export interface ChecklistFieldProps {
  id: string;
  name: string;
  label: string;
  'aria-invalid': boolean;
  touched: boolean;
  error?: string;
  onBlur: () => void;
  onChange: (e: CustomChangeEvent<string[]>) => void;
  value: string[];
  options: Array<{ label: string; value: string }>;
}

export const ChecklistField: FC<ChecklistFieldProps> = ({
  id,
  name: _name,
  label,
  'aria-invalid': ariaInvalid,
  touched: _touched,
  error,
  onBlur,
  onChange,
  value,
  options,
}) => {
  const shouldShowDropdown = options.length > FIELD_OPTIONS_THRESHOLD;
  const hasError = ariaInvalid;

  const handleChange = (newValue: string[]) => {
    onChange({ name: _name, value: newValue });
  };

  return (
    <>
      {label && (
        <Text weight='regular' css={fieldLabelTextStyle}>
          {label}
        </Text>
      )}
      {!shouldShowDropdown ? (
        <InlineChecklistField options={options} fieldId={id} value={value} onChange={handleChange} onBlur={onBlur} />
      ) : (
        <DropdownChecklistField
          options={options}
          fieldId={id}
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          hasError={hasError}
        />
      )}
      {hasError && error && (
        <Text size='small' css={errorMessageStyle}>
          {error}
        </Text>
      )}
    </>
  );
};
